export const ORDER_TAG = 'Order' as const
export const MACHINES_TAG = 'Machines' as const
